import {useLayoutEffect} from 'react'

import {OptimizerStatus} from '../../../../shared/enums'
import {OptimizedSchedule} from '../../../../shared/interfaces/api'
import {useSelectedOptimizerPlan} from '../../SelectedOptimizerPlanProvider'
import {OptimizerScheduleType} from '../../shared/enums/optimizerSchedules'

import {OptimizerSchedule} from './useOptimizerPlansOverview'

export const useSelectLatestSuccessPlanOnMount = (optimizerSchedules: OptimizerSchedule[]) => {
  const {setSelectedInTableScheduleId, setVisibleScheduleId} = useSelectedOptimizerPlan()

  useLayoutEffect(() => {
    const latestSuccessfulPlan = [...optimizerSchedules]
      .reverse()
      .find(
        (schedule) =>
          schedule.type === OptimizerScheduleType.Optimized &&
          schedule.optimizationDetails.optimizerStatus === OptimizerStatus.Success
      ) as OptimizedSchedule | undefined

    setSelectedInTableScheduleId(latestSuccessfulPlan?.scheduleId)
    setVisibleScheduleId(latestSuccessfulPlan?.scheduleId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
